import { render } from "./StreakHelpModal.vue?vue&type=template&id=1436a1ef"
import script from "./StreakHelpModal.vue?vue&type=script&lang=js"
export * from "./StreakHelpModal.vue?vue&type=script&lang=js"

import "./StreakHelpModal.vue?vue&type=style&index=0&id=1436a1ef&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__